



























































































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { CourseListenerUnion as ICourseListenerUnion } from "@/api/models/course-listener-union";
import { mapGetters } from "vuex";
import finalDocument, {
  FinalDocumentParams
} from "@/getinfo-api/final-document";
import { FinalDocumentShort as IFinalDocumentShort } from "@/api/models/final-document-short";
import { FinalDocumentShortList as IFinalDocumentShortList } from "@/api/models/final-document-short-list";
import { EducationProtocol as IEducationProtocol } from "@/api/models/education-protocol";
import { getCurrentCompanyId } from "@/plugins/roles";
import CustomButton from "@/components/form/CustomButton.vue";
import { Student as IStudent } from "@/api-v2/course/models/student";
import { courseApi, laborProtectionApi } from "@/getinfo-api";
import { Worker as IWorker } from "@/api-v2/labor-protection/models/worker";
import Modal from "@/components/form/Modal.vue";
import UserStudentFiles from "@/components/user/UserStudentFiles.vue";
import {
  laborExportModule,
  studentDocumentModule
} from "@/plugins/modules-detect";

@Component({
  components: { UserStudentFiles, Modal, CustomButton },
  computed: {
    ...mapGetters({
      SELECTED_LISTENERS: "SELECTED_LISTENERS"
    })
  }
})
export default class ListenersTableItem extends Vue {
  @Prop() listener!: ICourseListenerUnion;
  @Prop({ default: false }) active!: boolean;
  @Prop() activeCheckbox!: boolean;
  @Prop() showFinalDoc!: boolean;
  @Prop() protocol!: IEducationProtocol;
  laborWorker?: IWorker;
  finalDocuments!: Array<IFinalDocumentShort>;
  showSpinner: boolean = false;
  gettingFinalDocument: boolean = false;
  student!: IStudent;
  isLaborLoading: boolean = false;

  data() {
    return {
      laborWorker: undefined,
      finalDocuments: undefined,
      student: undefined
    };
  }

  get screenWidth() {
    return window.innerWidth;
  }

  get selectedCompanyId() {
    return getCurrentCompanyId();
  }

  get isStudentDocumentModule() {
    return studentDocumentModule();
  }

  get isLaborModuleEnabled() {
    return laborExportModule();
  }

  get isNeedLaborColumn() {
    return this.isLaborModuleEnabled;
  }

  get listenerLink() {
    const listener = {
      name: "userProfileView",
      params: { id: this.listener?.user?.id }
    };
    const student = { name: "student", params: { id: this.student?.id } };

    //@ts-ignore
    return this.listener?.course?.version === "v1" ? listener : student;
  }

  setupChecked(listener: ICourseListenerUnion) {
    return this.$store.getters.SELECTED_LISTENERS.map(
      (el: ICourseListenerUnion) => el.id
    ).includes(listener.id);
  }

  get check() {
    return this.$store.getters.SELECTED_LISTENERS.map(
      (el: ICourseListenerUnion) => el.id
    ).includes(this.listener.id);
  }

  getStatus(listener: ICourseListenerUnion) {
    let status: string = "";
    if (listener.status === "success")
      status = this.$tc(this.$translate.Completed);
    if (listener.status === "learning")
      status = this.$tc(this.$translate.NotComplete);
    if (listener.status === "not_success")
      status = this.$tc(this.$translate.CompletedUnsuccessfully);
    return status;
  }

  createFinalDocumentByCurrentData() {
    this.$store.commit(
      "finalDocuments/SETUP_LISTENER_FOR_CREATE_DOCUMENT",
      this.listener
    );
    this.$store.commit(
      "finalDocuments/SETUP_PROTOCOL_FOR_CREATE_DOCUMENT",
      this.protocol
    );
  }

  async getLaborWorker() {
    try {
      this.isLaborLoading = true;

      const response = await laborProtectionApi.Worker.getWorker(
        this.protocol.id,
        this.listener.id
      );
      if (response?.data) {
        this.laborWorker = response.data;
      }
    } finally {
      this.isLaborLoading = false;
    }
  }

  async deleteLaborWorker() {
    try {
      this.isLaborLoading = true;

      const response = await laborProtectionApi.Worker.deleteWorker(
        this.protocol.id,
        this.listener.id,
        { validateStatus: false }
      );

      if (response?.status === 204 || response?.status === 200) {
        this.laborWorker = undefined;
      } else {
        await this.$store.dispatch("errorException", {
          vm: this,
          error: (response as unknown) as string
        });
      }
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLaborLoading = false;
    }
  }

  created() {
    if (this.isLaborModuleEnabled && this.protocol) {
      this.getLaborWorker();
    }
  }

  mounted() {
    if (this.listener && this.listener.version === "v2" && this.protocol) {
      courseApi.CourseRegistration.getCourseRegistration(this.listener.id).then(
        ({ data }) => {
          this.student = data.student;
        }
      );
      const params: FinalDocumentParams = {
        companyId: this.selectedCompanyId,
        listenersIds: [this.listener.id],
        protocolsIds: [this.protocol.id]
      };
      if (this.showFinalDoc) {
        this.gettingFinalDocument = true;
        finalDocument(params)
          .then((res: { data: IFinalDocumentShortList }) => {
            this.finalDocuments = res.data.items;
            this.$store.commit(
              "finalDocuments/ADD_TO_LIST",
              this.finalDocuments
            );
          })
          .finally(() => {
            this.gettingFinalDocument = false;
          });
      }
    } else if (this.listener && this.protocol) {
      const params: FinalDocumentParams = {
        companyId: this.selectedCompanyId,
        listenersIds: [this.listener.id],
        protocolsIds: [this.protocol.id]
      };
      if (this.showFinalDoc) {
        this.gettingFinalDocument = true;
        finalDocument(params)
          .then((res: { data: IFinalDocumentShortList }) => {
            this.finalDocuments = res.data.items;
            this.$store.commit(
              "finalDocuments/ADD_TO_LIST",
              this.finalDocuments
            );
          })
          .finally(() => {
            this.gettingFinalDocument = false;
          });
      }
    }
  }
}
